import { Button, Card, CardActions, CardContent, colors, Grid, Modal, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { ErrorMessage } from 'components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Mastery, Student } from "services";
import useErrorCatcher from "utils/useErrorCatcher";

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  container: {
    marginTop: theme.spacing(3)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  saveButton: {
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  label: {
    fontSize: 18
  },
}));

let mounted = false;

const SetActiveMastery = props => {
  const { open, onClose, className, reload, activeMastery, student_id, ...rest } = props;

  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));
  const [masteries, setMasteries] = useState([]);
  const [mastery, setMastery] = useState(activeMastery);

  useEffect(() => {
    mounted = true;
    runAsyncBlock(async () => {
      const { models } = await Mastery.list({ query: { limit: 9999 } });
      mounted && setMasteries(models);
      return () => { mounted = false };
    }).finally(() => mounted && setLoading(false));
  }, []); // eslint-disable-line

  if (!open) {
    return null;
  }

  const handleClose = event => {
    event.preventDefault();

    mounted && setLoading(true);
    runAsyncBlock(async () => {
      await Student.update_mastery({ student_id, mastery_level_id: mastery });
      mounted && setLoading(false);
      reload();
    }).finally(() => {
      onClose();
    });

  }
  const handleMasteryChange = event => {
    event.persist();
    let id = event.target.value;
    let mastery = masteries.find(mastery => mastery.id === parseInt(id))
    setMastery(mastery.id);
  };

  return (
    <Modal
      onClose={onClose}
      open={open}>
      <Card
        {...rest}
        className={clsx(classes.root, className)}>
        <form>
          <CardContent>
            <Typography align="center" gutterBottom variant="h3">
              Set Active Mastery
            </Typography>
            <Grid className={classes.container} container spacing={3}>
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  label="Mastery"
                  name="mastery"
                  onChange={handleMasteryChange}
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{ native: true }}
                  value={mastery}
                  variant="outlined"
                  InputLabelProps={{ shrink: true, classes: { root: classes.label } }}
                  select
                >
                  <option disabled value={""} label="Select Mastery" />
                  {masteries && masteries.length > 0 && masteries.map((mastery, index) => (
                    <option key={index} value={mastery.id} >{mastery.name_en} {mastery.name_zh}</option>
                  ))}
                </TextField>
              </Grid>
              <ErrorMessage message={errorMessage} className={classes.error} />
              <Grid item />
            </Grid>
          </CardContent>
          <CardActions className={classes.actions}>
            <Button onClick={onClose} variant="contained">Close</Button>
            <Button className={classes.saveButton} onClick={handleClose} variant="contained" disabled={loading} >Save</Button>
          </CardActions>
        </form>
      </Card>
    </Modal >
  );
};

SetActiveMastery.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

SetActiveMastery.defaultProps = {
  open: false,
  onClose: () => { }
};

export default SetActiveMastery;
